var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"{organization-label}: Edit Media Assets"}},[_c('v-container',{staticStyle:{"padding-left":"15px","padding-right":"15px"},attrs:{"fluid":""}},[_c('m-media-asset-search',{attrs:{"organization_id":_vm.$route.params.organization_id,"content_type":_vm.$route.params.content_type}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }